module.exports = __webpack_public_path__ + "img/glaive_thrower_small.4107706e.png";